import { useEffect, useState } from "react";
import { t } from "i18next";
import humanizeDuration from "humanize-duration";
import { PiPersonSimpleWalkLight } from "react-icons/pi";

import useMapStore from "@/store/mapStore";
import { cn } from "@/lib/utils";

function PoiDetailsDistance({ className }: { className?: string }) {
  const routeDetails = useMapStore((state) => state.routeDetails);
  const currentLanguage = useMapStore((state) => state.currentLang);
  const mobileMode = useMapStore((state) => state.mobileMode);
  const [distanceInMeters, setDistanceInMeters] = useState(0);
  const [distanceInMinutes, setDistanceInMinutes] = useState("");

  useEffect(() => {
    setDistanceInMeters(Math.round(routeDetails?.details?.distance));

    let humanizedDuration = humanizeDuration(
      routeDetails?.details?.duration.realistic * 1000,
      {
        delimiter: ` ${t("and")} `,
        units: ["m"],
        largest: 1,
        round: true,
        language: currentLanguage,
      },
    );
    if (mobileMode) {
      humanizedDuration = humanizedDuration.replace(" minute", "min");
    }

    setDistanceInMinutes(humanizedDuration);
  }, [
    routeDetails?.details?.distance,
    currentLanguage,
    routeDetails?.details?.duration.realistic,
    mobileMode,
  ]);

  return (
    <div
      className={cn("flex items-center gap-2 text-sm lg:text-base", className)}
    >
      <PiPersonSimpleWalkLight className="text-lg text-primary" />
      <span>
        {t("distance")}{" "}
        <strong>
          {distanceInMeters}
          {currentLanguage === "en" ? "m" : "ﻡ"} / {distanceInMinutes}
        </strong>
      </span>
    </div>
  );
}

export default PoiDetailsDistance;
